import LoggerReducer from 'store/logger/reducer';

export { default as loggerTypes } from 'store/logger/types';
export { default as loggerOperations } from 'store/logger/operations';
export { default as loggerSelectors } from 'store/logger/selectors';
export { default as loggerActions } from 'store/logger/actions';

export default LoggerReducer;
